import { render } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=5440a227&scoped=true"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"

import "./FrequentlyAskedQuestions.vue?vue&type=style&index=0&id=5440a227&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5440a227"]])

export default __exports__